module.exports = __webpack_public_path__ + "img/arch-sup-sel.062e6594.svg";